import { render } from "./MyAccounts.vue?vue&type=template&id=9fd8b0b4"
import script from "./MyAccounts.vue?vue&type=script&lang=js"
export * from "./MyAccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__